import React from 'react';
import UserService from '../../services/userService'

export default function withAuth(WrappedComponent){
  return class extends React.Component{
    async componentDidMount() {
      const isAuthenticated = await UserService.isAuthenticated();
      if (!isAuthenticated) {
        this.props.history.replace('/login')
      }
    }
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
}